module.exports = __webpack_public_path__ + "img/toeic3.df236c9a.png";